import translate from "../../helpers/translate";
import capitalize from "../../helpers/capitalize";

export default {
  install(Vue, options) {
    options.keys.forEach(key => {
      Vue.prototype[`$t${capitalize(key)}`] = function (value, count) {
        return translate(value, count, key)
      }

      Vue.filter(`t${capitalize(key)}`, function (value, count) {
        return translate(value, count, key)
      })
    })
  }
}
